import { baseUrl, machineStatuses } from "./constants";
import {
  getToken,
  getUser,
  retreiveCachedResponse,
  cacheResponse
} from "./storage";
import { logout } from "./login";

export async function getMachine(barcode) {
  let data, rtn;

  try {
    if (barcode === "") {
      return { success: 0, data: "Please enter or scan the serial number" };
    }

    let token = await getToken();
    let response = await fetch(`${baseUrl}/machines/number/${barcode}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    // const statusCode = response.status;

    let resData = await response.json();

    if (resData.success === 0) {
      rtn = { success: 0, data: resData.error.msg };
      new Error(resData.error);
    } else {
      data = resData.data;
      rtn = { success: 1, data };
      cacheResponse(`getMachine:${barcode}`, data);
    }
  } catch (err) {
    if (
      err.message === "token_not_provided" ||
      err.message === "request_failed"
    )
      throw new Error(err.message);
      console.error(JSON.stringify(err));

    data = await retreiveCachedResponse(`getMachine:${barcode}`);
  }

  return rtn;
}

export async function updateMachine({ machine }) {
  let token = await getToken();
  let user = await getUser();
  let response = await (await fetch(`${baseUrl}/inspection/machine/store`, {
    method: "POST",
    body: JSON.stringify({
      user_id: user.id,
      machines: [machine],
      store_id: machine.store_id,
      priority: machine.priority || "Medium",
      inspection_note: machine.inspection_note || "No note"
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })).json();
  return response;
}

export async function getMachineFromId(id) {
  let data;

  try {
    let token = await getToken();
    let response = await (await fetch(`${baseUrl}/machines/machine_id/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    })).json();

    if (response.success === 0 && response.error)
      throw new Error(response.error);
    data = response.data;

    cacheResponse(`getMachineFromId:${id}`, data);
  } catch (err) {
    if (err.message === "token_not_provided") throw new Error(err.message);

    console.log(err);
    data = await retreiveCachedResponse(`getMachineFromId:${id}`);
  }

  return data;
}

export async function sendMachine({
  storeId,
  storeName,
  branchId,
  courierNumber,
  courierNumber2,
  branchRecordId,
  machineId,
}) {
  let rtn;

  try {
    const body = JSON.stringify({
      store_id: storeId,
      branch_id: branchId,
      courier_number: courierNumber,
      courier_number2: courierNumber2,
      branchRecordId: branchRecordId,
      machine_id: machineId
    });

    let token = await getToken();

    let response = await fetch(`${baseUrl}/branches/assign`, {
      method: "POST",
      body,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    await response
      .json()
      .then(resData => {
        if (resData.success === 1) {
          rtn = { success: true };
        } else {
          rtn = { success: false, message: resData.error.msg };
        }
      })
      .catch(e => console.log(e.message));
    return rtn;
  } catch (e) {
    console.log("SEND MACHINE ERROR ==>", e.message);
  }
}

export async function searchTool(code) {
  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/search/wh_tools`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ tool_code: code })
  })).json();

  return response;
}

export async function sendTool({
  storeId,
  storeName,
  branchId,
  courierNumber,
  courierNumber2,
  branchRecordId,
  toolId,
  //bag_id,
}) {
  let rtn;

  try {
    const body = JSON.stringify({
      store_id: storeId,
      branch_id: branchId,
      courier_number: courierNumber,
      courier_number2: courierNumber2,
      branchRecordId: branchRecordId,
      tool_id: toolId/*,
      bag_id : bag_id,*/
    });

    let token = await getToken();
    let response = await fetch(`${baseUrl}/branches/assign`, {
      method: "POST",
      body,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    await response
      .json()
      .then(resData => {
        if (resData.success === 1) {
          rtn = { success: true };
        } else {
          rtn = { success: false, message: resData.error.msg };
        }
      })
      .catch(e => console.log(e.message));
    return rtn;
  } catch (e) {
    console.log("SEND TOOL ERROR ==>", e.message);
  }
}

export async function assignMachine(machineId) {
  let token = await getToken();

  let response = await await fetch(`${baseUrl}/warehouse/assign`, {
    method: "POST",
    body: JSON.stringify({
      machine_id: machineId
    }),
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  });

  return response;
}

export async function updateMachineStatus(
  machineId,
  status,
  courierNumber = null,
  courierNumber2 = null,
) {
  if (!machineStatuses.includes(status)) {
    throw new Error(status, "not in list of machine statuses", machineStatuses);
  }

  let token = await getToken();
  try {
    const { data } = await (await fetch(
      `${baseUrl}/machines/${machineId}/hire_status/${status}/courier/${courierNumber}`,
      {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` }
      }
    )).json();
    return data;
  } catch (err) {
    if (err.message === "token_not_provided") throw new Error(err.message);
  }
}

export async function createMachine({
  barcode,
  code,
  serial_number,
  machine_hours = 0,
  hire_status
}) {
  let token = await getToken();
  let user = await getUser();
  const { data, success, error } = await (await fetch(
    `${baseUrl}/machines/create`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        barcode,
        m_code: code,
        serial_number,
        m_hours: machine_hours,
        hire_status,
        user_id: user.id
      })
    }
  )).json();

  if (success === 0 && error) throw new Error(error);

  if (success === 1) {
    return data;
  }
}

export async function updateMachineBarcode(machine_id, barcode) {
  let token = await getToken();
  let response = await (await fetch(
    `${baseUrl}/machines/${machine_id}/barcode/${barcode}`,
    {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    }
  )).json();
  return response;
}

export async function searchMachines(machine_code) {
  let token = await getToken();
  let mappedResponse = [];

  try {
    let response = await (await fetch(`${baseUrl}/search/machines`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        machine_code
      })
    })).json();
    if (response.success === 0 && response.error)
      throw new Error(response.error);
    // Convert to format react-select wants
    mappedResponse = response.data.data.map(({ id, code }) => ({
      value: id,
      label: code
    }));
    cacheResponse(`searchMachines:${machine_code}`, mappedResponse);
  } catch (err) {
    if (err.message === "token_not_provided") throw new Error(err.message);
    console.error(err);
    mappedResponse = await retreiveCachedResponse(
      `searchMachines:${machine_code}`
    );
  }

  return mappedResponse;
}

export async function getRequestList(request_type) {

  if(!request_type) {
    request_type = '';
  }

  let token = await getToken();
  let response = await (await fetch(`${baseUrl}/branches/request_list?request_type=${request_type}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    },
  })).json();
  if (response.error == 'token_expired'){
    logout()

    const { history } = this.props;
    return event => {
      history.push("/login");
    };
  }
  return response.data;
}



// WEBPACK FOOTER //
// ./src/backend/machine.js